import axios from 'axios';

import config from '../config'

import { AiServiceOptions } from '@/types/suppliers'

const instance = axios.create({
    baseURL: config.tenderMvcSiteUrl,
    timeout: 10000000,
    withCredentials: true,
    headers: { Pragma: 'no-cache' }
});

export class TenderMvcSite {
    public static getAiServiceSuggestions = (data: AiServiceOptions) => instance.post('/Dictionary/GetAiServiceSuggestions', data);
}